import actionTypes from "./actionTypes.js";
import namespace from './namespace';
export default {
  namespace,
  state: {
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0
    },
    readFlag: ""
  },
  reducers: {
    [actionTypes.CHANGE_PAGE](state, action) {
      return { ...state,
        pagination: { ...state.pagination,
          ...action.data.pagination
        }
      };
    },

    [actionTypes.CHANGE_READFLAG](state, action) {
      return { ...state,
        readFlag: action.data.readFlag
      };
    }

  }
};